import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * A escala tipográfica do `tailwind.config.ts` precisa ser ensinada ao
 * tailwind-merge (E54.F2.T16). Com a config default ele não reconhece
 * `text-body-sm` como tamanho, classifica no grupo de **cor** e descarta a
 * classe anterior do mesmo grupo — silenciosamente. O efeito medido antes da
 * correção:
 *
 *     cn('text-body-sm', 'text-fg-onInverse')                 → 'text-fg-onInverse'
 *     cn('text-body-sm', 'text-fg-onInverse', 'text-body-md') → 'text-body-md'
 *
 * Ou seja: onde tamanho e cor de texto se encontram na mesma chamada, uma das
 * duas some. Declarando os degraus no grupo `font-size`, as duas convivem e só
 * conflitam com outra do mesmo eixo.
 */
const ESCALA_TIPOGRAFICA = [
  'display-xl',
  'display-lg',
  'display-md',
  'display-sm',
  'heading-lg',
  'heading-md',
  'heading-sm',
  'body-lg',
  'body-md',
  'body-sm',
  'caption',
  'mono-label',
];

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ESCALA_TIPOGRAFICA }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
